import types from '../types';
import {
    submitElement,
    deleteElement
} from '../common';
const apiUrl = '/api/distances';
export function toggleDistanceModal(toggle = true, distance = null) {
    return {
        type: types.TOGGLE_DISTANCE_MODAL,
        payload: {
            toggle,
            distance
        }
    }
}
export function submitDistance(values) {
    return submitElement(apiUrl, values, types.SUBMIT_DISTANCE);
}

export function removeDistance(distance) {
    return deleteElement(apiUrl, distance.id, types.DELETE_DISTANCE);
}



// WEBPACK FOOTER //
// ./src/js/actions/admin/distance-actions.js